import { render, staticRenderFns } from "./suggest_replace_part.vue?vue&type=template&id=5fb241d2&scoped=true"
import script from "./suggest_replace_part.vue?vue&type=script&lang=js"
export * from "./suggest_replace_part.vue?vue&type=script&lang=js"
import style0 from "./suggest_replace_part.vue?vue&type=style&index=0&id=5fb241d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb241d2",
  null
  
)

export default component.exports